import { render, staticRenderFns } from "./UiChartLegend.vue?vue&type=template&id=65222c22"
import script from "./UiChartLegend.vue?vue&type=script&lang=js"
export * from "./UiChartLegend.vue?vue&type=script&lang=js"
import style0 from "./UiChartLegend.vue?vue&type=style&index=0&id=65222c22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports